import JsPDF from "jspdf";
import "jspdf-autotable";

export const exportTableDataAsCSV = (bondsDaTableRef, file_name) => {
  if (bondsDaTableRef.current) {
    const table = bondsDaTableRef.current;
    const columns = [];
    const data = [];

    // Extract column headers
    for (let i = 0; i < table.rows[0].cells.length; i++) {
      // Wrap headers in double quotes and escape internal double quotes
      const header = `"${table.rows[0].cells[i].innerText.replace(/"/g, '""')}"`;
      columns.push(header);
    }

    // Extract data rows
    for (let i = 1; i < table.rows.length; i++) {
      const rowData = [];
      for (let j = 0; j < table.rows[i].cells.length; j++) {
        // Wrap data in double quotes and escape internal double quotes
        const cellText = `"${table.rows[i].cells[j].innerText.replace(/"/g, '""')}"`;
        rowData.push(cellText);
      }
      data.push(rowData);
    }

    // Prepare CSV content
    let csvContent = columns.join(",") + "\n";
    data.forEach(row => {
      csvContent += row.join(",") + "\n";
    });

    // Create a blob with the CSV content
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Trigger a download for the user
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${file_name}_bonds_table.csv`);
    document.body.appendChild(link);
    link.click();

    // Clean up
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }
};




  export const exportTableAsPDF=(bondsDaTableRef,file_name)=>{


    if (bondsDaTableRef.current) {
      const table = bondsDaTableRef.current;
      const columns = [];
      const data = [];

      // Extract column headers
      for (let i = 0; i < table.rows[0].cells.length; i++) {
        columns.push(table.rows[0].cells[i].innerText);
      }

      // Extract data rows
      for (let i = 1; i < table.rows.length; i++) {
        const rowData = [];
        for (let j = 0; j < table.rows[i].cells.length; j++) {
          rowData.push(table.rows[i].cells[j].innerText);
        }
        data.push(rowData);
      }

      const doc = new JsPDF('l', 'pt', 'letter');
      doc.autoTable({
        head: [columns],
        body: data,
        theme: 'grid',
        columnStyles: {
            0: {
                tableWidth: 100,
                },
            1: {
                tableWidth: 200,
               },
            2: {
                halign: 'right',
                tableWidth: 100,
               },
            3: {
                halign: 'right',
                tableWidth: 100,
               },
            4: {
                halign: 'center',
                tableWidth: 50,
               },
            5: {
                halign: 'center',
                tableWidth: 50,
               },
            6: {
                halign: 'center',
                tableWidth: 50,
               }
        },
      });
      doc.save(`${file_name}_bonds.pdf`);
  

    }

    return false;



  }

